import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Plus, Grid, User } from "lucide-react";

function CommunityHeader({ onOpenCreateModal }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="bg-white/90 backdrop-blur-md shadow-xs border-b border-gray-100 sticky top-16 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          {/* Navigation Tabs */}
          <div className="flex items-center space-x-1 sm:space-x-2">
            <Link
              to="/community"
              className={`flex items-center space-x-2 px-3.5 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all ${
                isActive("/community")
                  ? "bg-purple-600 text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`}
            >
              <Grid size={16} />
              <span>All Community Feed</span>
            </Link>
            <Link
              to="/community/myposts"
              className={`flex items-center space-x-2 px-3.5 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all ${
                isActive("/community/myposts")
                  ? "bg-purple-600 text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`}
            >
              <User size={16} />
              <span>My Posts</span>
            </Link>
          </div>

          {/* Create Post Button */}
          <button
            onClick={onOpenCreateModal}
            className="flex items-center space-x-2 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-xl shadow-md hover:shadow-lg transition-all font-semibold text-xs sm:text-sm"
          >
            <Plus size={18} />
            <span className="hidden sm:inline">Create Post</span>
            <span className="sm:hidden">Post</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default CommunityHeader;